import React from 'react';
import { Col, Container, Image, Row } from 'react-bootstrap';
import QueryForm from '../../../Pages/Static/queryForm';
import FrederiqueConstantBanner from '../../../../Assets/images/alicias-img/frederique-constant.png';
import FrederiqueConstantBannerMobile from '../../../../Assets/images/alicias-img/frederique-constant-mobile.png';

import { isMobileOnly } from 'react-device-detect';
const FrederiqueConstant = () => {
  return (
    <>
      <div className="watch_repaire_services_page">
        <Container fluid>
          <Row>
            <Col sm={12} md={12} lg={12} className="p-0">
              <div>{isMobileOnly ? <Image src={FrederiqueConstantBannerMobile} className="img-fluid"  alt='Oris'/> : <Image src={FrederiqueConstantBanner} className="img-fluid"  alt='Oris'/>}</div>
            </Col>
          </Row>
        </Container>
        <Container>
          <div className="text-center pt-5">
            <Row className="justify-content-center">
              <Col lg={8}>
                <h3 className="text-center text-uppercase">Frederique Constant</h3>
                <p>
                  Step into sophistication with Frederique Constant, where contemporary style meets classic elegance. Each timepiece is a blend of meticulous craftsmanship and innovative design, making it the perfect accessory for those who appreciate quality and refinement. A Frederique Constant watch is more than just a timepiece; it’s a symbol of your unique taste and individuality. Whether you’re dressing up for a formal event or adding a touch of luxury to your everyday look, this watch enhances your style effortlessly. Elevate your wristwear with
                </p>
              </Col>
            </Row>
          </div>
        </Container>
        <QueryForm />
      </div>
    </>
  );
};

export default FrederiqueConstant;
